var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"text-center mt-2"},[_vm._v("Aging Range By Vehicle Type")]),_c('hr'),_c('div',{ref:"minMaxAging",staticStyle:{"min-height":"500px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }